import { LibraryAPI } from '@business/api/library';
import { tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { ItemId, LibraryItemOptionResponse } from '@business/entities/library';
import { PolicyBlockVariation } from './PolicyBlock';

export class PolicyBlockBloc extends BaseBloc {
  constructor(private variation: PolicyBlockVariation) {
    super();
  }

  items$ = new BehaviorSubject<LibraryItemOptionResponse[] | null>(null);
  readonly loading = new LoadingState();

  onInit() {
    return LibraryAPI.getLibraryItemOptions(this.variation).pipe(
      tap(data => this.items$.next(data)),
      this.loading.run(),
    );
  }

  getContent = (id: ItemId) => LibraryAPI.getLibraryItemContent(id);
}
